export default __webpack_public_path__ + "static/media/i3.1af20b2f.jpg";